import { Model } from "backbone"

export default class Comments extends Model {
  url() {
    if (this.user.isEditor()) {
      return `/content/${this.content_id}/comments/for-editor`
    } else {
      return `/content/${this.content_id}/comments`
    }
  }

  initialize(options) {
    this.content_id = options.content_id
    this.user = options.user
  }
}
